import type { FC } from 'react';
import { Grid, Box, Button } from '@mui/material';
import ImageSelectionGrid from './ImageSelectionGrid';
import TemplateSelectionGrid, { ITemplate } from './TemplateSelectionGrid';
import type { IMediaLibraryImageModel } from '@/shared/models/media-library/media-library-image.model';
import PropertyDetailsForm from './PropertyDetailsForm';
import type { PlatformType } from '@/editor/shared/constants/available-platforms';
import { useAppSelector } from '@/store/hooks/redux';
import { useGetCreatomateTemplatesQuery } from '@/editor/services/http/creatomate.api';

interface IGenerateVideoTabProps {
  isNextTab: number;
  onNextTabChange: (value: number) => void;
  imageData: IMediaLibraryImageModel[];
  imageDataLoading: boolean;
  selected: IMediaLibraryImageModel[];
  isSelected: (image: IMediaLibraryImageModel) => boolean;
  onToggleSelect: (image: IMediaLibraryImageModel) => void;
  platform: PlatformType;
  selectedTemplateId: string | null;
  onTemplateSelect: (templateId: string) => void;
  onGenerateVideo: () => void;
}

const GenerateVideoTab: FC<IGenerateVideoTabProps> = ({
  isNextTab,
  onNextTabChange,
  imageData,
  imageDataLoading,
  selected,
  isSelected,
  onToggleSelect,
  platform,
  selectedTemplateId,
  onTemplateSelect,
  onGenerateVideo,
}) => {
  const propertyExtId = useAppSelector((state) => state.propertyInfoSliceReducer.propertyExtId);
  const storedCompanyId = useAppSelector((state) => state.propertyInfoSliceReducer.companyId);

  const { data: creatomateTemplates } = useGetCreatomateTemplatesQuery({
    propertyExtId,
    companyId: storedCompanyId,
  });

  const templates = creatomateTemplates?.templateData?.templates || [];

  return (
    <Grid item xs={12}>
      <Box sx={{ display: 'flex', justifyContent: 'end', p: 1 }}>
        {isNextTab !== 1 && (
          <Button variant="contained" onClick={() => onNextTabChange(1)}>
            back
          </Button>
        )}
        {selected.length === 4 && isNextTab !== 2 && (
          <Button variant="contained" onClick={() => onNextTabChange(2)}>
            next
          </Button>
        )}
      </Box>

      {isNextTab === 1 && (
        <ImageSelectionGrid
          imageData={imageData}
          imageDataLoading={imageDataLoading}
          selected={selected}
          isSelected={isSelected}
          onToggleSelect={onToggleSelect}
          platform={platform}
        />
      )}

      {isNextTab === 2 && (
        <Grid>
          <PropertyDetailsForm platform={platform} />
          <TemplateSelectionGrid
            templates={templates}
            selectedTemplateId={selectedTemplateId}
            onTemplateSelect={onTemplateSelect}
          />

          {selectedTemplateId && selected.length > 0 && (
            <Box
              sx={{
                backgroundColor: 'white',
                bottom: -1,
                display: 'flex',
                justifyContent: 'end',
                position: 'sticky',
                p: 1,
              }}>
              <Button
                onClick={onGenerateVideo}
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: '#000',
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: '#e6952f',
                  },
                }}>
                generateVideo
              </Button>
            </Box>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default GenerateVideoTab;
